export default __webpack_public_path__ + "static/piotrc-bb3eec32c50143998bb87c59a72f1107.jpg";